module.exports = __webpack_public_path__ + "img/nav01.8cac209b.png";